import React, { useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SendIcon from "@mui/icons-material/Send";
import Stack from "@mui/material/Stack";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Grid from "@mui/material/Grid";
import AuthContext from "../../context/AuthContext";
import Select from "react-dropdown-select";
import { createTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { TopicType } from "../../utils/types";

const TopicForm = () => {
  let { user } = useContext(AuthContext);

  const [alertShow, setAlertShow] = useState(false);
  const [open, setOpen] = useState(false);

  const [topic, setTopic] = useState<TopicType>({
    label: "",
    id: 0,
    creator: "",
    creator_id: 0,
  });
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let newTopic = async (event) => {
    event.preventDefault();
    const response = await fetch(`/api/topics/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(topic),
    });

    const data = await response.json();

    navigate(`/topic/${data.id}`);
  };

  return (
    <div>
      <Grid container justifyContent="flex-end">
        <Button
          variant="outlined"
          onClick={handleClickOpen}
          endIcon={<PostAddIcon />}
          style={{
            maxWidth: "180px",
            maxHeight: "32px",
            minWidth: "100px",
            minHeight: "32px",
          }}
        >
          {window.innerWidth > 700 ? "Neues Thema" : ""}
        </Button>
      </Grid>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <form onSubmit={newTopic} id="NewTopicForm">
          <Box>
            {alertShow && (
              <Alert severity="error" onClose={() => setAlertShow(false)}>
                Bitte melde dich an um einen neues Thema zu erstellen.{" "}
                <Link href="/login">Hier anmelden.</Link>
              </Alert>
            )}
          </Box>

          <DialogTitle>Neues Thema</DialogTitle>
          <DialogContent>
            <TextField
              style={{
                marginTop: 20,
              }}
              required
              autoFocus
              margin="dense"
              id="label"
              name="label"
              label="Name"
              type="text"
              fullWidth
              variant="standard"
              value={topic.label}
              onChange={(e) => setTopic({ ...topic, label: e.target.value })}
            />
          </DialogContent>

          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={handleClose}>
                Abbrechen
              </Button>
              <Button variant="contained" endIcon={<SendIcon />} type="submit">
                Erstellen
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

export default TopicForm;
